import styled from "styled-components"
import Button from "@irati/ui/src/Button"

export default styled(Button)`
  width: calc(100% - 60px);
  position: fixed;
  bottom: 30px;
  display: block;
  z-index: 999;
  max-width: 690px;
  margin-left: 15px;
  margin-right: 15px;
`
